import { Box, Breadcrumbs, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Notification from "../Notification";
import UniversityNotify from "./UniversityNotify";
import CourseNotify from "./CourseNotify";
import ContactUs from "./ContactUs";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 3 } }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Notifyme() {
  const [value, setValue] = React.useState(
    Number(localStorage.getItem("NotifyTabIndex")) || 0,
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("NotifyTabIndex", newValue);
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: { xs: 1, md: 0 },
          mb: 2,
          mt: 1,
          marginLeft: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Notify Management
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#17479e",
                height: 2,
              },
            }}
            sx={{
              "& .MuiTab-root": {
                color: "#555",
                fontWeight: 600,
                textTransform: "none",
                minWidth: "120px", // mobile friendly
              },
              "& .Mui-selected": {
                color: "#17479e !important",
              },
            }}
          >
            <Tab label="Books Notify" {...a11yProps(0)} />
            <Tab label="Universities Notify" {...a11yProps(1)} />
            <Tab label="Courses Notify" {...a11yProps(2)} />
            <Tab label="Contact Us" {...a11yProps(3)} />
            {/* <Tab label="States" {...a11yProps(4)} />
            <Tab label="Look Ups" {...a11yProps(5)} />
            <Tab label="Subject Categories" {...a11yProps(6)} /> */}
          </Tabs>
        </Box>

        <CustomTabPanel
          value={value}
          index={0}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <Notification />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <UniversityNotify />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={2}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <CourseNotify />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <ContactUs />
        </CustomTabPanel>
      </Box>
    </>
  );
}

export default Notifyme;
